import axios from "axios";

const API = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,
});

/** Normalize FastAPI/axios errors to a readable string. */
export function apiError(e) {
    const d = e?.response?.data?.detail;
    if (d == null) return e?.message || "Qualcosa è andato storto. Riprova.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
        return d
            .map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x)))
            .filter(Boolean)
            .join(" ");
    }
    if (d && typeof d.msg === "string") return d.msg;
    return String(d);
}

// ---------------------------------------------------------------------------
// Silent session refresh — 401 handler
// ---------------------------------------------------------------------------
// If any authenticated call returns 401, we transparently ask the backend
// to renew the access_token via the refresh_token cookie and retry the
// original request exactly once. The user never sees anything.
//
//  * Deduplication: concurrent 401s share the same refresh promise so we
//    only fire one /auth/refresh at a time.
//  * Bypass list: never intercept the refresh endpoint itself or explicit
//    login/logout calls to avoid infinite loops.
//  * If the refresh itself fails (e.g. refresh_token expired after 30 days
//    of inactivity), the original 401 is surfaced to the caller so the app
//    can redirect to /login as usual.
// ---------------------------------------------------------------------------

const AUTH_BYPASS = /\/auth\/(refresh|login|logout|register)$/;
let refreshInFlight = null;

API.interceptors.response.use(
    (r) => r,
    async (error) => {
        const original = error?.config;
        const status = error?.response?.status;
        if (
            status !== 401 ||
            !original ||
            original._retried ||
            AUTH_BYPASS.test(original.url || "")
        ) {
            return Promise.reject(error);
        }
        original._retried = true;
        try {
            refreshInFlight =
                refreshInFlight ||
                API.post("/auth/refresh").finally(() => {
                    refreshInFlight = null;
                });
            await refreshInFlight;
            return API.request(original);
        } catch (e) {
            return Promise.reject(error);
        }
    }
);

export default API;
